import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/miguplay/html/19521/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      // meta: {
      //   // keepAlive: true
      // }
    },
   
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.name === 'home') {
      // setTimeout(() => {
      //   if (savedPosition) {
      //     console.log('xy', savedPosition.x, savedPosition.y)
      //     window.scrollTo(savedPosition.x, savedPosition.y)
      //   }
      // }, 500)
      // return {savedPosition}
    }
    return {x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js